import React from 'react'
import { useStore } from '../../state/store'
import { STYLE_LABELS, STYLE_LIST, StyleType } from '../../core/types'

const StyleSelector: React.FC = () => {
  const { settings, setStyle } = useStore()

  return (
    <div className="panel-section">
      <div className="xp-section-header">
        <h3 className="panel-title">渲染风格</h3>
      </div>
      <div className="xp-section-body space-y-2">
        <label className="xp-group-label" htmlFor="style-selector">
          当前引擎
        </label>
        <select
          id="style-selector"
          value={settings.style}
          onChange={(e) => setStyle(e.target.value as StyleType)}
          className="xp-select"
        >
          {STYLE_LIST.map((style) => (
            <option key={style} value={style}>
              {STYLE_LABELS[style]}
            </option>
          ))}
        </select>
        <div className="xp-note">
          当前选择: {STYLE_LABELS[settings.style]}
        </div>
      </div>
    </div>
  )
}

export default StyleSelector
